var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('div',[_vm._v("Holiday")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',[_vm._v("\n            "+_vm._s(_vm.holidays.length ? `${_vm.holidays.length} People` : "None")+"\n        ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }